<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.approve.trucker.label.title')}}</h4>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import List from './ListTrucker';
import Controller from './CrtTrucker';

export default {
  name: 'Trucker',
  components: {
    List,
  },
  data() {
      return {
        errors: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
    }
  },
  methods: Controller.methods,
  created() {
         Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
